// Inline icons for the top bar. Drawn with currentColor so they follow the
// theme, and marked hidden because every one sits inside a labeled control.

const PATHS: Record<string, string> = {
  search: 'M10.5 3a7.5 7.5 0 105.06 13.06l3.69 3.69 1.41-1.41-3.69-3.69A7.5 7.5 0 0010.5 3zm0 2a5.5 5.5 0 110 11 5.5 5.5 0 010-11z',
  message: 'M4 4h16a1 1 0 011 1v11a1 1 0 01-1 1H8l-4 4V5a1 1 0 011-1z',
  gear: 'M12 8a4 4 0 100 8 4 4 0 000-8zm9 4a8.6 8.6 0 00-.1-1.3l2-1.6-2-3.4-2.4 1a8.9 8.9 0 00-2.2-1.3L15.9 3h-3.8l-.4 2.4a8.9 8.9 0 00-2.2 1.3l-2.4-1-2 3.4 2 1.6a8.6 8.6 0 000 2.6l-2 1.6 2 3.4 2.4-1a8.9 8.9 0 002.2 1.3l.4 2.4h3.8l.4-2.4a8.9 8.9 0 002.2-1.3l2.4 1 2-3.4-2-1.6c.06-.43.1-.86.1-1.3z',
  person: 'M12 12a5 5 0 100-10 5 5 0 000 10zm0 2c-4.4 0-8 2.5-8 5.5V21h16v-1.5c0-3-3.6-5.5-8-5.5z',
  jump: 'M4 4h7v2H6v12h12v-5h2v7H4V4zm9 0h7v7h-2V7.41l-7.29 7.3-1.42-1.42L16.59 6H13V4z',
  calendar: 'M7 2v2H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V6a2 2 0 00-2-2h-2V2h-2v2H9V2H7zM5 10h14v10H5V10z',
  layout: 'M3 3h8v8H3V3zm10 0h8v5h-8V3zM3 13h8v8H3v-8zm10-3h8v11h-8V10z',
};

export function Glyph({ name }: { name: keyof typeof PATHS | string }) {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
      <path d={PATHS[name] ?? PATHS.person} fill="currentColor" />
    </svg>
  );
}
